exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".collapsible .collapsed-triangle-icon{display:inline-block;margin-right:5px;vertical-align:middle}.collapsible.date-filters{width:427px}.collapsible.date-filters .date-picker-container{display:inline-block;margin-bottom:10px}.collapsible.date-filters .date-picker-container:nth-child(odd){margin-right:20px}.collapsible.date-filters .date-picker-label{font-weight:700}.collapsible.date-filters .date-filter-p{display:inline-block!important;color:#27638c;font-weight:700}.collapsible.date-filters .date-filter-p:hover{cursor:pointer}.collapsible.date-filters .react-datepicker__input-container{display:block}.collapsible.date-filters .date-picker{background-color:#fff;border-radius:4px;border:1px solid #ccc;color:#333;height:20px;padding:4px}.collapsible.date-filters .date-picker.validation-error{border:1px solid red}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader!./~/less-loader!./src/less/collapsible.less
// module id = 1640
// module chunks = 0